.categoryCard {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 18rem;
  align-items: stretch;
  overflow: hidden;
  padding: var(--space-6);
  border-radius: var(--radius-xl);
  color: var(--color-play-card-text);
  background: var(--color-play-daily);
  border: 0;
  font: inherit;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  box-shadow: var(--shadow-control);
  transition: box-shadow var(--duration-normal) var(--ease-standard);
}

.categoryCard[data-category='series'] {
  background: var(--color-play-party);
}
.categoryCard[data-category='games'] {
  background: var(--color-play-endless);
}
.categoryCard[data-category='anime'] {
  background: var(--color-play-collections);
}

.categoryCard:focus-visible {
  outline: 0.1875rem solid var(--color-focus);
  outline-offset: 0.1875rem;
}

.categoryArtBubble {
  position: absolute;
  top: calc(var(--space-5) * -1);
  right: calc(var(--space-4) * -1);
  display: grid;
  width: min(48%, 10rem);
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: var(--radius-pill);
  background: color-mix(in srgb, var(--color-play-card-text) 11%, transparent);
  place-items: center;
  pointer-events: none;
  transform: rotate(12deg);
}

.categoryArt {
  width: 79%;
  height: 79%;
  object-fit: contain;
  opacity: 0.78;
  transform: rotate(-21deg);
}
.categoryCard[data-large-artwork] .categoryArtBubble {
  width: min(54%, calc(var(--space-16) * 3));
}
.categoryCard[data-large-artwork] .categoryArt {
  width: 85%;
  height: 85%;
}

.categoryCopy {
  position: relative;
  z-index: 1;
  display: grid;
  min-width: 0;
  width: 100%;
  justify-items: start;
  gap: var(--space-4);
  grid-template-rows: auto 1fr auto auto;
}

.categoryCopy > strong {
  font-family: var(--font-family-display);
  font-size: clamp(1.5rem, 3vw, 2rem);
  line-height: 1.1;
  overflow-wrap: anywhere;
  white-space: nowrap;
}

.categoryProgress {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-pill);
  font-size: 0.875rem;
  font-weight: 850;
  align-self: end;
  transition: transform var(--duration-fast) var(--ease-standard);
}

.categoryProgress:not([data-variant='game']) {
  color: inherit;
  background: var(--color-play-mode-chip-bg);
  box-shadow:
    inset 0 0.0625rem 0 var(--color-play-secondary-action-highlight),
    0 0.1875rem 0 var(--color-play-mode-chip-edge),
    0 0.5rem 1rem var(--color-play-secondary-action-shadow);
}

.categoryCard:active .categoryProgress {
  transform: translateY(0.125rem);
}

@media (hover: hover) and (pointer: fine) {
  .categoryCard:not([data-disabled]):hover {
    box-shadow: var(--shadow-block);
  }
  .categoryCard[data-disabled]:not(:disabled):hover {
    opacity: 0.85;
    box-shadow: var(--shadow-control);
  }
  .categoryCard:not([data-disabled]):hover .categoryProgress svg {
    transform: translateX(var(--space-1));
  }
  .categoryProgress svg {
    transition: transform var(--duration-normal) var(--ease-standard);
  }
}
.categoryCard:disabled {
  cursor: default;
}
.categoryCard[data-disabled][data-complete] {
  color: var(--color-text-secondary);
  background: var(--color-surface-subtle);
}
.categoryCard[data-disabled][data-complete] .categoryArt {
  filter: grayscale(1);
}
@media (max-width: 35.99em) {
  .categoryCard {
    min-height: 16rem;
    padding: var(--space-5);
  }
}

.categoryCard[data-compact] {
  min-height: 12rem;
}

.categoryCard[data-dense] {
  min-height: 16rem;
  padding: var(--space-5);
}

.categoryCard[data-dense] .categoryCopy {
  gap: var(--space-3);
  grid-template-rows: auto 1fr auto auto;
}

.categoryCard[data-dense][data-hide-action] {
  min-height: 14rem;
}

.categoryCard[data-dense][data-hide-action] .categoryCopy {
  grid-template-rows: auto 1fr auto;
}
.categoryCard[data-compact] .categoryCopy {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--space-2);
}
.categoryCard[data-compact] .categoryProgress {
  align-self: flex-start;
  margin-top: auto;
}
.categoryCard .categoryProgress[data-complete] {
  color: var(--color-surface-raised);
  background: var(--color-notice-success);
  box-shadow:
    inset 0 0.125rem 0 rgb(255 255 255 / 0.35),
    0 0.25rem 0 color-mix(in srgb, var(--color-notice-success) 75%, black),
    0 0.625rem 1.25rem var(--color-play-action-shadow);
}
@media (max-width: 35.99em) {
  .categoryCard[data-compact] {
    min-height: 11rem;
  }
}

@media (max-width: 39.99em) {
  .categoryCard[data-dense][data-hide-action] {
    min-height: 11.5rem;
    padding: var(--space-5);
  }

  .categoryCard[data-dense][data-hide-action] .categoryCopy {
    gap: var(--space-2);
  }
}
